import script from "./BrillenInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BrillenInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__